/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
const classNameIcon = "svg-icon";
const iconSize = 24;

interface IconProps {
  color?: string;
  size?: string | number;
};

export const ArrowDownIcon = ({
  color,
  size,
} : IconProps) => {
  return (
    <>
      <svg width={size ?? iconSize} height={size ?? iconSize} className={classNameIcon} viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={color ?? 'currentColor'} d="M515.536 652.464C513.583 654.417 510.417 654.417 508.464 652.464L285.867 429.867C269.372 413.372 269.372 386.628 
        285.867 370.133V370.133C302.362 353.638 329.105 353.638 345.6 370.133L512 536.533L678.4 370.133C694.895 353.638 721.638 353.638 738.133 370.133V370.133C754.628 
        386.628 754.628 413.372 738.133 429.867L515.536 652.464Z" />
      </svg>
    </>
  );
};

export const ArrowNavIcon = ({
  color,
  size,
} : IconProps) => {
  return (
    <>
      <svg width={size ?? iconSize} height={size ?? iconSize} className={classNameIcon} viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={color ?? 'currentColor'} d="M395.729 737.062C412.727 754.06 440.36 753.818 457.057 736.524V736.524C473.345 719.654 473.11 692.844 456.529 
        676.262L334.933 554.667H810.667C834.231 554.667 853.333 535.564 853.333 512V512C853.333 488.436 834.231 469.333 810.667 469.333H334.933L456.529 347.738C473.11 
        331.156 473.345 304.346 457.057 287.476V287.476C440.36 270.182 412.727 269.94 395.729 286.938L174.202 508.464C172.25 510.417 172.25 513.583 174.202 515.536L395.729 
        737.062Z" />
      </svg>
    </>
  );
};

export const SearchIcon = ({
  color,
  size,
} : IconProps) => {
  return (
    <>
      <svg width={size ?? iconSize} height={size ?? iconSize} className={classNameIcon} viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={color ?? 'currentColor'} d="M843.338 888.929C839.433 892.834 833.101 892.834 829.196 888.929L567.467 627.2C546.133 644.267 521.6 657.778 493.867 
        667.733C466.133 677.689 436.622 682.667 405.333 682.667C327.822 682.667 262.229 655.829 208.555 602.155C154.852 548.452 128 482.844 128 405.333C128 327.822 
        154.852 262.215 208.555 208.512C262.229 154.837 327.822 128 405.333 128C482.844 128 548.452 154.837 602.155 208.512C655.829 262.215 682.667 327.822 682.667 
        405.333C682.667 436.622 677.689 466.133 667.733 493.867C657.778 521.6 644.267 546.133 627.2 567.467L888.929 829.196C892.834 833.101 892.834 839.433 888.929
         843.338L843.338 888.929ZM405.333 597.333C458.667 597.333 504.007 578.674 541.355 541.355C578.674 504.007 597.333 458.667 597.333 405.333C597.333 352 578.674 
         306.66 541.355 269.312C504.007 231.993 458.667 213.333 405.333 213.333C352 213.333 306.66 231.993 269.312 269.312C231.993 306.66 213.333 352 213.333 
         405.333C213.333 458.667 231.993 504.007 269.312 541.355C306.66 578.674 352 597.333 405.333 597.333Z" />
      </svg>
    </>
  );
};

export const AlertIcon = ({
  color,
  size,
} : IconProps) => {
  return (
    <>
      <svg width={size ?? iconSize} height={size ?? iconSize} className={classNameIcon} viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={color ?? 'currentColor'} d="M44.4011 896C43.6308 896 43.1497 895.166 43.5357 894.499L511.135 86.8282C511.52 86.1629 512.48 86.1629 512.865 
        86.8282L980.464 894.499C980.85 895.166 980.369 896 979.599 896H44.4011ZM189.867 810.667H834.133L512 256L189.867 810.667ZM512 768C524.089 768 534.229 
        763.904 542.421 755.712C550.585 747.548 554.667 737.422 554.667 725.333C554.667 713.244 550.585 703.118 542.421 694.955C534.229 686.763 524.089 682.667
         512 682.667C499.911 682.667 489.785 686.763 481.621 694.955C473.429 703.118 469.333 713.244 469.333 725.333C469.333 737.422 473.429 747.548 481.621 
         755.712C489.785 763.904 499.911 768 512 768ZM469.333 639C469.333 639.552 469.781 640 470.333 640H553.667C554.219 640 554.667 639.552 554.667 639V427.667C554.667 
         427.114 554.219 426.667 553.667 426.667H470.333C469.781 426.667 469.333 427.114 469.333 427.667V639Z" />
      </svg>
    </>
  );
};

export const CloseIcon = ({
  color,
  size,
} : IconProps) => {
  return (
    <>
      <svg width={size ?? iconSize} height={size ?? iconSize} className={classNameIcon} viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={color ?? 'currentColor'} d="M302.933 787.3C286.438 803.795 259.695 803.795 243.2 787.3V787.3C226.705 770.805 226.705 744.062 243.2 727.567L452.267 
        518.5L243.2 309.433C226.705 292.938 226.705 266.195 243.2 249.7V249.7C259.695 233.205 286.438 233.205 302.933 249.7L512 458.767L721.067 249.7C737.562 233.205 
        764.305 233.205 780.8 249.7V249.7C797.295 266.195 797.295 292.938 780.8 309.433L571.733 518.5L780.8 727.567C797.295 744.062 797.295 770.805 780.8 787.3V787.3C764.305
         803.795 737.562 803.795 721.067 787.3L512 578.233L302.933 787.3Z" />
      </svg>
    </>
  );
};

export const CheckIcon = ({
  color,
  size,
} : IconProps) => {
  return (
    <>
      <svg width={size ?? iconSize} height={size ?? iconSize} className={classNameIcon} viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={color ?? 'currentColor'} d="M408.174 767.826C407.783 768.217 407.15 768.217 406.76 767.826L164.974 526.04C164.583 525.65 164.583 525.017 164.974 
        524.626L224.36 465.24C224.75 464.85 225.383 464.85 225.774 465.24L407.467 646.933L798.226 256.174C798.617 255.783 799.25 255.783 799.64 256.174L859.026 
        315.56C859.417 315.95 859.417 316.583 859.026 316.974L408.174 767.826Z" />
      </svg>
    </>
  );
};

export const CheckFillIcon = ({
  color,
  size,
} : IconProps) => {
  return (
    <>
      <svg width={size ?? iconSize} height={size ?? iconSize} className={classNameIcon} viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={color ?? 'currentColor'} d="M512 938.667C452.978 938.667 397.511 927.46 345.6 905.045C293.689 882.66 248.533 852.267 210.133 813.867C171.733 
        775.467 141.34 730.311 118.955 678.4C96.5404 626.489 85.3333 571.022 85.3333 512C85.3333 452.978 96.5404 397.511 118.955 345.6C141.34 293.689 171.733 
        248.533 210.133 210.133C248.533 171.733 293.689 141.326 345.6 118.912C397.511 96.5262 452.978 85.3333 512 85.3333C571.022 85.3333 626.489 96.5262 678.4 
        118.912C730.311 141.326 775.467 171.733 813.867 210.133C852.267 248.533 882.66 293.689 905.045 345.6C927.46 397.511 938.667 452.978 938.667 512C938.667 
        571.022 927.46 626.489 905.045 678.4C882.66 730.311 852.267 775.467 813.867 813.867C775.467 852.267 730.311 882.66 678.4 905.045C626.489 927.46 571.022 
        938.667 512 938.667ZM448.731 704.731C450.684 706.684 453.85 706.684 455.802 704.731L723.2 437.333C739.695 420.838 739.695 394.095 723.2 377.6V377.6C706.705 
        361.105 679.962 361.105 663.467 377.6L452.267 588.8L360.533 497.067C344.038 480.572 317.295 480.572 300.8 497.067V497.067C284.305 513.562 284.305 540.305 
        300.8 556.8L448.731 704.731Z" />
      </svg>
    </>
  );
};

export const AddCircleIcon = ({
  color,
  size,
} : IconProps) => {
  return (
    <>
      <svg width={size ?? iconSize} height={size ?? iconSize} className={classNameIcon} viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={color ?? 'currentColor'} d="M469.333 682.667C469.333 706.231 488.436 725.333 512 725.333V725.333C535.564 725.333 554.667 706.231 554.667 
        682.667V554.667H682.667C706.231 554.667 725.333 535.564 725.333 512V512C725.333 488.436 706.231 469.333 682.667 469.333H554.667V341.333C554.667 317.769 
        535.564 298.667 512 298.667V298.667C488.436 298.667 469.333 317.769 469.333 341.333V469.333H341.333C317.769 469.333 298.667 488.436 298.667 512V512C298.667 
        535.564 317.769 554.667 341.333 554.667H469.333V682.667ZM512 938.667C452.978 938.667 397.511 927.46 345.6 905.045C293.689 882.66 248.533 852.267 210.133 
        813.867C171.733 775.467 141.34 730.311 118.955 678.4C96.5404 626.489 85.3333 571.022 85.3333 512C85.3333 452.978 96.5404 397.511 118.955 345.6C141.34 293.689 
        171.733 248.533 210.133 210.133C248.533 171.733 293.689 141.326 345.6 118.912C397.511 96.5262 452.978 85.3333 512 85.3333C571.022 85.3333 626.489 96.5262 678.4 
        118.912C730.311 141.326 775.467 171.733 813.867 210.133C852.267 248.533 882.66 293.689 905.045 345.6C927.46 397.511 938.667 452.978 938.667 512C938.667 571.022 
        927.46 626.489 905.045 678.4C882.66 730.311 852.267 775.467 813.867 813.867C775.467 852.267 730.311 882.66 678.4 905.045C626.489 927.46 571.022 938.667 512 
        938.667ZM512 853.333C606.578 853.333 687.118 820.096 753.621 753.621C820.096 687.118 853.333 606.578 853.333 512C853.333 417.422 820.096 336.882 753.621 
        270.379C687.118 203.904 606.578 170.667 512 170.667C417.422 170.667 336.896 203.904 270.421 270.379C203.918 336.882 170.667 417.422 170.667 512C170.667 
        606.578 203.918 687.118 270.421 753.621C336.896 820.096 417.422 853.333 512 853.333Z" />
      </svg>
    </>
  );
};

export const OrderIcon = ({
  color,
  size,
} : IconProps) => {
  return (
    <>
      <svg width={size ?? iconSize} height={size ?? iconSize} className={classNameIcon} viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={color ?? 'currentColor'} d="M384 554.667C360.436 554.667 341.333 535.564 341.333 512V248.533L261.335 328.532C244.796 345.07 218.02 345.189 
        201.336 328.798V328.798C184.442 312.2 184.321 285.012 201.068 268.265L373.917 95.4164C379.486 89.8477 388.514 89.8477 394.083 95.4164L566.932 268.265C583.679 
        285.012 583.558 312.2 566.664 328.798V328.798C549.98 345.189 523.204 345.07 506.665 328.532L426.667 248.533V512C426.667 535.564 407.564 554.667 384 
        554.667V554.667ZM650.083 928.584C644.514 934.152 635.486 934.152 629.917 928.584L457.068 755.734C440.321 738.988 440.442 711.8 457.336 695.202V695.202C474.02 
        678.811 500.796 678.93 517.335 695.468L597.333 775.467V512C597.333 488.436 616.436 469.333 640 469.333V469.333C663.564 469.333 682.667 488.436 682.667 
        512V775.467L762.665 695.468C779.204 678.93 805.98 678.811 822.664 695.202V695.202C839.558 711.8 839.679 738.988 822.932 755.735L650.083 928.584Z" />
      </svg>
    </>
  );
};

export const VisibilityOffIcon = ({
  color,
  size,
} : IconProps) => {
  return (
    <>
      <svg width={size ?? iconSize} height={size ?? iconSize} className={classNameIcon} viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={color ?? 'currentColor'} d="M655.127 537.212L604.509 486.594C609.745 459.249 601.891 433.648 580.945 409.794C560 385.939 532.945 376.63 499.782 
        381.867L449.164 331.249C459.055 326.594 469.085 323.103 479.255 320.776C489.449 318.449 500.364 317.285 512 317.285C555.636 317.285 592.733 332.552 623.29 
        363.086C653.824 393.643 669.091 430.739 669.091 474.376C669.091 486.012 667.927 496.927 665.6 507.12C663.273 517.291 659.782 527.321 655.127 537.212ZM766.836 
        647.176L716.218 598.303C738.327 581.43 757.969 562.952 775.145 542.867C792.297 522.806 806.982 499.976 819.2 474.376C790.109 415.612 748.358 368.915 693.946 
        334.286C639.558 299.679 578.909 282.376 512 282.376C495.127 282.376 478.545 283.539 462.255 285.867C445.964 288.194 429.964 291.685 414.255 296.339L360.145 
        242.23C384 232.339 408.436 224.915 433.455 219.958C458.473 215.025 484.655 212.558 512 212.558C599.855 212.558 678.109 236.843 746.764 285.413C815.418 
        334.006 865.164 396.994 896 474.376C882.618 508.703 865.024 540.563 843.217 569.957C821.388 599.327 795.927 625.067 766.836 647.176ZM808.654 
        837.504C795.175 850.983 773.342 851.048 759.782 837.65L637.673 716.994C617.309 723.394 596.806 728.2 576.163 731.411C555.497 734.6 534.109 
        736.194 512 736.194C424.145 736.194 345.891 711.909 277.236 663.339C208.582 614.745 158.836 551.758 128 474.376C140.218 443.539 155.636 
        414.879 174.255 388.395C192.873 361.934 214.109 338.23 237.964 317.285L166.07 244.084C152.721 230.493 152.82 208.683 166.29 195.213V195.213C179.847 
        181.657 201.826 181.656 215.383 195.213L808.654 788.484C822.19 802.021 822.19 823.967 808.654 837.504V837.504ZM286.836 366.158C269.964 381.285 
        254.545 397.867 240.582 415.903C226.618 433.939 214.691 453.43 204.8 474.376C233.891 533.139 275.631 579.825 330.019 614.431C384.431 649.061 
        445.091 666.376 512 666.376C523.636 666.376 534.982 665.654 546.036 664.211C557.091 662.745 568.436 661.139 580.073 659.394L548.655 626.23C542.255 
        627.976 536.145 629.279 530.327 630.14C524.509 631.024 518.4 631.467 512 631.467C468.364 631.467 431.267 616.2 400.71 585.666C370.176 555.109 
        354.909 518.012 354.909 474.376C354.909 467.976 355.34 461.867 356.201 456.049C357.085 450.23 358.4 444.121 360.145 437.721L286.836 366.158Z" />
      </svg>
    </>
  );
};

export const VisibilityOnIcon = ({
  color,
  size,
} : IconProps) => {
  return (
    <>
      <svg width={size ?? iconSize} height={size ?? iconSize} className={classNameIcon} viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={color ?? 'currentColor'} d="M512 674.909C555.636 674.909 592.733 659.642 623.29 629.108C653.824 598.551 669.091 561.455 669.091 517.818C669.091 
        474.182 653.824 437.085 623.29 406.528C592.733 375.994 555.636 360.727 512 360.727C468.364 360.727 431.267 375.994 400.71 406.528C370.176 437.085 354.909 
        474.182 354.909 517.818C354.909 561.455 370.176 598.551 400.71 629.108C431.267 659.642 468.364 674.909 512 674.909ZM512 612.073C485.818 612.073 463.569 
        602.903 445.254 584.564C426.915 566.249 417.745 544 417.745 517.818C417.745 491.636 426.915 469.376 445.254 451.037C463.569 432.721 485.818 423.564 512 
        423.564C538.182 423.564 560.442 432.721 578.781 451.037C597.097 469.376 606.255 491.636 606.255 517.818C606.255 544 597.097 566.249 578.781 584.564C560.442 
        602.903 538.182 612.073 512 612.073ZM512 779.636C427.055 779.636 349.673 755.921 279.855 708.492C210.036 661.085 159.418 597.527 128 517.818C159.418 438.109 
        210.036 374.54 279.855 327.11C349.673 279.703 427.055 256 512 256C596.945 256 674.327 279.703 744.145 327.11C813.964 374.54 864.582 438.109 896 517.818C864.582 
        597.527 813.964 661.085 744.145 708.492C674.327 755.921 596.945 779.636 512 779.636ZM512 709.818C577.745 709.818 638.115 692.503 693.108 657.873C748.079 
        623.267 790.109 576.582 819.2 517.818C790.109 459.055 748.079 412.358 693.108 377.728C638.115 343.121 577.745 325.818 512 325.818C446.255 325.818 385.885 
        343.121 330.892 377.728C275.921 412.358 233.891 459.055 204.8 517.818C233.891 576.582 275.921 623.267 330.892 657.873C385.885 692.503 446.255 709.818 512 709.818Z" />
      </svg>
    </>
  );
};

export const FilterIcon = ({
  color,
  size,
} : IconProps) => {
  return (
    <>
      <svg width={size ?? iconSize} height={size ?? iconSize} className={classNameIcon} viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={color ?? 'currentColor'} d="M469.333 853.333C457.244 853.333 447.118 849.237 438.955 841.045C430.763 832.882 426.667 822.756 426.667 810.667V554.667L179.2 
        238.933C168.533 224.711 166.94 209.778 174.421 194.133C181.874 178.489 194.844 170.667 213.333 170.667H810.667C829.156 170.667 842.14 178.489 849.621 194.133C857.074 
        209.778 855.467 224.711 844.8 238.933L597.333 554.667V810.667C597.333 822.756 593.252 832.882 585.088 841.045C576.896 849.237 566.756 853.333 554.667 
        853.333H469.333ZM512 524.8L723.2 256H300.8L512 524.8Z" />
      </svg>
    </>
  );
};

export const PencilIcon = ({
  color,
  size,
} : IconProps) => {
  return (
    <>
      <svg width={size ?? iconSize} height={size ?? iconSize} className={classNameIcon} viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={color ?? 'currentColor'} d="M842.563 285.41L738.575 181.492C735.16 178.061 731.101 175.339 726.631 173.481C722.161 171.623 717.367 170.667 
        712.526 170.667C707.686 170.667 702.892 171.623 698.422 173.481C693.952 175.339 689.893 178.061 686.477 181.492L234.681 633.291C222.111 645.858 213.565 
        661.881 210.131 679.321L171.354 826.55C170.417 830.164 170.442 833.961 171.425 837.562C172.409 841.164 174.317 844.446 176.961 847.082C179.604 849.719 
        182.891 851.618 186.495 852.592C190.1 853.566 193.896 853.58 197.508 852.634L344.666 813.857C362.144 810.472 378.203 801.92 390.766 789.307L842.563 
        337.578C849.462 330.65 853.336 321.271 853.336 311.494C853.336 301.717 849.462 292.338 842.563 285.41ZM711.933 229.197L794.23 311.494L737.25 368.474L654.953 
        286.177L711.933 229.197ZM618.338 324.048L699.728 405.438L375.492 729.746L294.102 648.285L618.338 324.048ZM331.624 773.336L322.278 775.986C289.708 785.122 
        253.232 798.652 219.756 808.626C219.236 808.776 218.686 808.782 218.163 808.645C217.64 808.507 217.164 808.231 216.785 807.845C216.406 807.459 216.139 
        806.978 216.011 806.452C215.883 805.927 215.9 805.376 216.06 804.86L248.56 701.43L251.35 692.294C251.656 691.314 252.21 690.43 252.96 689.729C253.71 
        689.028 254.629 688.534 255.628 688.295C256.626 688.056 257.669 688.081 258.655 688.366C259.642 688.651 260.536 689.188 261.253 689.922C286.221 714.96 
        310.073 738.743 334.274 763.153C335.018 763.902 335.554 764.832 335.828 765.852C336.102 766.872 336.105 767.945 335.838 768.967C335.57 769.988 335.041 
        770.922 334.302 771.676C333.563 772.43 332.64 772.978 331.624 773.266V773.336Z" stroke={color ?? 'currentColor'} strokeWidth="0.5"/>
      </svg>
    </>
  );
};

export const TrashIcon = ({
  color,
  size,
} : IconProps) => {
  return (
    <>
      <svg width={size ?? iconSize} height={size ?? iconSize} className={classNameIcon} viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={color ?? 'currentColor'} d="M298.667 896C275.2 896 255.118 887.652 238.421 870.955C221.696 854.229 213.333 834.133 213.333 810.667V256H175.667C172.905 
        256 170.667 253.761 170.667 251V175.667C170.667 172.905 172.905 170.667 175.667 170.667H384V133C384 130.239 386.239 128 389 128H635C637.761 128 640 130.239 
        640 133V170.667H848.333C851.095 170.667 853.333 172.905 853.333 175.667V251C853.333 253.761 851.095 256 848.333 256H810.667V810.667C810.667 834.133 802.318 
        854.229 785.621 870.955C768.896 887.652 748.8 896 725.333 896H298.667ZM725.333 256H298.667V810.667H725.333V256ZM384 725.333H469.333V341.333H384V725.333ZM554.667 
        725.333H640V341.333H554.667V725.333Z" />
      </svg>
    </>
  );
};

export const AgentsIcon = ({
  color,
  size,
} : IconProps) => {
  return (
    <>
      <svg width={size ?? iconSize} height={size ?? iconSize} className={classNameIcon} viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={color ?? 'currentColor'} d="M643.84 607.572C603.733 588.372 563.2 573.865 521.813 564.052L483.84 736.425H451.84C444.587 677.119 436.907 653.225 
        429.227 604.585L453.973 570.025C462.08 558.505 453.973 542.719 439.893 542.719H347.307C333.227 542.719 325.12 558.505 333.227 570.025L360.96 608.852C352.427 
        656.212 344.747 682.239 337.067 736.852H309.76L269.653 564.479C228.267 574.292 187.733 588.799 147.627 607.999C128.853 617.385 113.92 631.039 102.4 648.532C90.88 
        666.452 85.3333 685.652 85.3333 706.985V811.519H706.133V706.985C706.133 685.652 700.587 666.452 689.067 648.532C677.973 630.612 662.613 617.385 643.84 
        607.999V607.572Z" />
        <path fill={color ?? 'currentColor'} d="M920.32 648.96C907.947 633.6 890.453 619.947 866.987 607.574C841.813 594.347 814.507 583.254 785.493 574.294C756.48 
        565.334 725.333 558.934 692.48 555.094C721.493 573.014 744.107 594.774 759.893 619.947C775.68 645.12 783.787 671.574 783.787 698.88V810.667H939.093V698.88C939.093 
        680.96 933.12 664.32 920.747 648.96H920.32V648.96Z" />
        <path fill={color ?? 'currentColor'} d="M573.867 504.747C581.12 506.453 590.08 508.16 601.173 509.867C612.267 511.573 621.227 512 628.48 512C671.147 512 707.84 
        497.493 738.133 468.053C768.427 438.613 783.787 403.627 783.787 362.667C783.787 321.707 768.427 286.293 738.133 257.28C707.84 227.84 671.147 213.333 628.48 
        213.333C619.52 213.333 610.56 213.333 601.173 214.613C592.213 215.467 583.253 217.6 573.867 220.587C591.36 240.64 604.587 262.4 613.973 286.72C623.36 311.04 
        628.053 336.213 628.053 362.24C628.053 388.267 623.36 413.44 613.973 437.76C604.587 462.08 591.36 484.267 573.867 503.893V504.747V504.747Z" />
        <path fill={color ?? 'currentColor'} d="M405.76 502.217C364.8 502.217 329.387 488.137 300.373 459.977C270.933 431.817 256 397.257 256 357.577C256 317.897 270.933 
        283.764 300.373 255.177C328.96 227.017 364.8 212.938 405.76 212.938C446.72 212.938 482.133 227.017 511.147 255.177C540.587 283.337 555.52 317.897 555.52 
        357.577C555.52 397.257 540.587 431.391 511.147 459.977C482.133 488.137 446.72 502.217 405.76 502.217ZM405.76 276.511C382.293 276.511 362.667 284.191 345.6 
        300.404C328.96 316.617 320.853 334.964 320.853 357.151C320.853 379.337 328.96 398.111 345.6 413.897C362.24 430.111 381.867 437.791 405.76 437.791C429.653 
        437.791 449.28 430.111 465.92 413.897C482.56 397.684 490.667 379.337 490.667 357.151C490.667 334.964 482.56 316.191 465.92 300.404C448.853 284.191 429.653 
        276.511 405.76 276.511Z" />
      </svg>
    </>
  );
};

export const GridViewIcon = ({
  color,
  size,
} : IconProps) => {
  return (
    <>
      <svg width={size ?? iconSize} height={size ?? iconSize} className={classNameIcon} viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={color ?? 'currentColor'} d="M128 469.333V128H469.333V469.333H128ZM128 896V554.667H469.333V896H128ZM554.667 469.333V128H896V469.333H554.667ZM554.667 
        896V554.667H896V896H554.667ZM213.333 384H384V213.333H213.333V384ZM640 384H810.667V213.333H640V384ZM640 810.667H810.667V640H640V810.667ZM213.333 
        810.667H384V640H213.333V810.667Z" />
      </svg>
    </>
  );
};

export const DocumentIcon = ({
  color,
  size,
} : IconProps) => {
  return (
    <>
      <svg width={size ?? iconSize} height={size ?? iconSize} className={classNameIcon} viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill={color ?? 'currentColor'} d="M341.333 768H682.667V682.667H341.333V768ZM341.333 597.333H682.667V512H341.333V597.333ZM256 938.667C232.533 938.667 
        212.444 930.311 195.733 913.6C179.022 896.889 170.667 876.8 170.667 853.333V170.667C170.667 147.2 179.022 127.111 195.733 110.4C212.444 93.6889 232.533 
        85.3333 256 85.3333H597.333L853.333 341.333V853.333C853.333 876.8 844.978 896.889 828.267 913.6C811.556 930.311 791.467 938.667 768 938.667H256ZM554.667 
        384V170.667H256V853.333H768V384H554.667Z" />
      </svg>
    </>
  );
};
